import { Reveal } from "./Reveal";

const CARDS = [
    {
        n: "01",
        title: "Pillar-driven training",
        copy: "Modules mapped to six culture pillars — Learning, Collaboration, Project Delivery, Innovation, Performance & Recognition, Engagement & Support — with rich-text content and draft/publish versioning.",
        span: "md:col-span-4",
    },
    {
        n: "02",
        title: "Challenge capture",
        copy: "Team members finish every module with the real-world challenges they face applying it, and can request intervention from leadership in one click.",
        span: "md:col-span-2",
    },
    {
        n: "03",
        title: "1:1 activity tracker",
        copy: "Admins log discussions, tag action items with Open / In Progress / Complete, attach files, and keep a private paper trail across every check-in.",
        span: "md:col-span-2",
    },
    {
        n: "04",
        title: "My Culture Score",
        copy: "Four signals — metrics, survey, admin evaluation, streak — combine into a live 0-100 culture score per team member, with auto-renormalising weights.",
        span: "md:col-span-4",
    },
    {
        n: "05",
        title: "Institutional & organisational metrics",
        copy: "Toggle the deeper institutional metric set per user; keep the organisational baseline for everyone else. Reports slice both cleanly.",
        span: "md:col-span-3",
    },
    {
        n: "06",
        title: "Multi-tenant, RBAC-first",
        copy: "Platform Admin, Org Admin, Manager, and Team Member roles enforce boundaries on every endpoint. Each org's data stays fully isolated.",
        span: "md:col-span-3",
    },
];

export const Capabilities = () => (
    <section id="platform" data-testid="platform-section" className="bg-[#FAFAFA] py-24 lg:py-36">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <Reveal>
                <p className="flex items-center gap-4 text-xs font-bold uppercase tracking-[0.3em] text-[#1FA187]">
                    <span className="h-px w-10 bg-[#1FA187]" />
                    The platform
                </p>
            </Reveal>
            <Reveal delay={0.08}>
                <h2 className="font-display mt-6 max-w-4xl text-4xl font-bold tracking-tight text-[#0A1B3F] sm:text-5xl">
                    Close the gap between what leadership expects, what teams practise, and{" "}
                    <span className="text-[#1E3A8A]">what the culture score actually shows.</span>
                </h2>
            </Reveal>
            <div className="mt-16 grid gap-5 md:grid-cols-6">
                {CARDS.map((card, i) => (
                    <Reveal key={card.n} delay={i * 0.06} className={`${card.span} h-full`}>
                        <article
                            data-testid={`capability-card-${card.n}`}
                            className="group flex h-full flex-col border border-slate-200 bg-white p-8 transition-[transform,box-shadow,border-color] duration-500 hover:-translate-y-1.5 hover:border-[#1E3A8A]/50 hover:shadow-[0_24px_60px_-24px_rgba(10,27,63,0.25)] lg:p-10"
                        >
                            <span className="font-display text-sm font-semibold tracking-[0.2em] text-[#1FA187]">
                                {card.n}
                            </span>
                            <h3 className="font-display mt-6 text-xl font-semibold tracking-tight text-[#0A1B3F] lg:text-2xl">
                                {card.title}
                            </h3>
                            <p className="mt-4 text-sm leading-relaxed text-slate-600 lg:text-base">
                                {card.copy}
                            </p>
                        </article>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
